<div class="modal fade" id="dialogRelatorioCompra" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="bg-primary modal-header text-white"  style="font-size: 1rem;">
        ORDENS DE FORNECIMENTO
      </div>
      <div class="modal-body pt-0">
        <p-fieldset legend="Opções do Relatório">
          <div class="form-row">
            <div class="col-sm-12">
              <span class="float-right" style="cursor: pointer;" (click)="menucompra_.toggle($event)"><i
                  class="fa fa-plus text-success"></i> Adicionar Filtro</span>
              <p-menu #menucompra_ appendTo="body" [popup]="true" [model]="menuFiltros"></p-menu>
            </div>
          </div>
          <div class="form-row pt-2">
            <ng-container *ngFor="let filtro of listaFiltros">
              <div [ngClass]="ngClassCols(filtro.cols, 'col-sm-12')" *ngIf="filtro.tipo === 'Number'"
                class="form-group">
                <div class="form-row">
                  <div class="col-sm-5">
                    <label [for]="filtro.coluna">{{filtro.titulo}} Inicial</label>
                    <input [id]="filtro.coluna" [name]="filtro.coluna" type="number" class="form-control"
                      [(ngModel)]="filtro.filtro1" style="float: left;">
                  </div>
                  <div class="col-sm-5">
                    <label [for]="filtro.coluna">{{filtro.titulo}} Final</label>
                    <input [id]="filtro.coluna" [name]="filtro.coluna" type="number" class="form-control"
                      [(ngModel)]="filtro.filtro2" style="float: left;">
                  </div>
                  <div class="col-sm-2" style="margin-top: auto;">
                    <button (click)="removerFiltro(filtro)" class="btn btn-sm btn-outline-danger ml-1"
                      style="height: 36px; width: 36px;">
                      <i class="fa fa-close"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div [ngClass]="ngClassCols(filtro.cols, 'col-sm-12')" *ngIf="filtro.tipo === 'String'"
                class="form-group">
                <label [for]="filtro.coluna">{{filtro.titulo}}</label>
                <input [id]="filtro.coluna" [name]="filtro.coluna" type="String" class="form-control"
                  [(ngModel)]="filtro.filtro1" [imask]="filtro.mask ? {mask: '0000/0000' } : null" [unmask]="true"
                  [style]="{ width: 'calc(100% - 40px)', float: 'left' }">
                <button (click)="removerFiltro(filtro)" class="btn btn-sm btn-outline-danger ml-1"
                  style="height: 36px; width: 36px;">
                  <i class="fa fa-close"></i>
                </button>
              </div>
              <div [ngClass]="ngClassCols(filtro.cols, 'col-sm-12')" *ngIf="filtro.tipo === 'Date'" class="form-group">
                <div class="form-row">
                  <div class="col-sm-5">
                    <label [for]="filtro.coluna">{{filtro.titulo}} Início</label>
                    <p-calendar [id]="filtro.coluna" [(ngModel)]="filtro.filtro1" inputStyleClass="form-control"
                      dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                      [showButtonBar]="true" [style]="{ width: '100%' }">
                    </p-calendar>
                  </div>
                  <div class="col-sm-5">
                    <label [for]="filtro.coluna">{{filtro.titulo}} Fim</label>
                    <p-calendar [id]="filtro.coluna" [(ngModel)]="filtro.filtro2" inputStyleClass="form-control"
                      dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                      [showButtonBar]="true" [style]="{ width: '100%' }">
                    </p-calendar>
                  </div>
                  <div class="col-sm-2 text-center d-flex justify-content-end align-items-end">
                    <button (click)="removerFiltro(filtro)" class="btn btn-sm btn-outline-danger"
                      style="height: 36px; width: 36px;">
                      <i class="fa fa-close"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </p-fieldset>
        <p-fieldset legend="Formatos">
          <p-radioButton name="formatoGroup" [value]="format" [label]="format" class="mr-2 mt-2" [(ngModel)]="formato"
            *ngFor="let format of listFormato">
          </p-radioButton>
        </p-fieldset>
        <p-fieldset legend="Tipo Relatório" *ngIf="formato === 'pdf'">
          <p-radioButton name="tipo" value="S" label="Sintética" class="mr-2 mt-2" [(ngModel)]="tipo">
          </p-radioButton>
          <p-radioButton name="tipo" value="A" label="Analítico" class="mr-2 mt-2" [(ngModel)]="tipo">
          </p-radioButton>
        </p-fieldset>
        <p-fieldset legend="Ordenação">
          <p-radioButton [value]="ordem" [label]="ordem.nome" class="mr-2 mt-2" [(ngModel)]="ordernacao"
            *ngFor="let ordem of listaOrdenacao">
          </p-radioButton>
        </p-fieldset>
      </div>
      <div class="modal-footer">
        <button (click)="imprimir()" type="button" class="btn btn-primary btn-sm">
          Gerar Relatório
        </button>
        <button type="button" class="btn btn-link btn-sm" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>